jQuery(document).ready(function ($) {
    ({
        init: function () {
            this.qty_control_action();
            this.getFancyBox();
            // this.get_slide();
            // this.get_slide_2();
            var x = this;
            setTimeout(function() {
                x.get_slide();
            }, 1000);
        },
        qty_control_action:function(){
            var control = $('.qty-box .control');
            var qty = $('.qty-box input');
            control.click(function(){
                var val = parseInt(qty.val()) ;
                if($(this).hasClass('control-down')){
                    if(val > 1){
                        qty.val(val-1);
                    }
                }
                if($(this).hasClass('control-up')){
                    qty.val(val+1);
                }
                
            })
        },
        getFancyBox:function(){
            $('.fancybox').fancybox({
                thumbs : {
                    autoPlay: true,
                    closeExisting: true,
                    arrows: true
                }
            });
        },
        get_slide: function(){
            // $(window).resize(function() {
            //     var ww = $(window).width();
            //     if (ww <= 1207) {
            //         $('.section-related-products').slick('setPosition');
            //     }
            // });
            $('.section-related-products').slick({
                slidesToShow: 7,
                slidesToScroll: 1,
                autoplay: true,
                centerMode: false,
                autoplaySpeed: 3000,
                dots: true,
                arrows: false,
                infinite: false,
                responsive: [
                    {
                      breakpoint: 1207,
                      settings: {
                        arrows: false,
                        autoplay: true,
                        slidesToShow: 5
                      }
                    },
                    {
                        breakpoint: 900,
                        settings: {
                          arrows: false,
                          autoplay: true,
                          slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                          arrows: false,
                          autoplay: true,
                          slidesToShow: 3
                        }
                    }
                ]
              });
            
        },
        get_slide_2: function(){
            $('.product-single-slide').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                // autoPlay: true,
                arrows: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                          slidesToShow: 3,
                          slidesToScroll: 1,
                          // infinite: true,
                          // dots: true
                        }
                    }
                ]
            });
            
      }             
    }).init()
});